// extracted by mini-css-extract-plugin
export default {"description":"ThirdScreen_description__okVz5","imageContainer":"ThirdScreen_imageContainer__dGEC4","image":"ThirdScreen_image__PB7cN","title":"ThirdScreen_title__LFW4K"};